import { getSignedData, getTimestamp, randomNum } from './utils'
import config from '../config'

const { baseSecret } = config

// 基础认证参数接口
export interface BaseAuthParams {
  appId: number
  timestamp: number
  random: string
  sign: string
}

// 定义请求配置接口
export interface BaseAuthConfig {
  appId?: number
  timestamp?: number
  random?: string
  secret?: string
  encode?: boolean
}

/**
 * 构造带签名的请求参数
 * @param params 原始参数
 * @param options 配置选项
 * @returns 带签名的参数
 */
export const generateAuth = <T extends Record<string, any>>(
  params?: T,
  options: BaseAuthConfig = {}
): T & BaseAuthParams => {
  const { random = randomNum(6), appId = 1004, timestamp = getTimestamp(), secret = baseSecret, encode = false } = options

  const authParams = {
    ...params,
    appId,
    timestamp,
    random,
    sign: ''
  } as T & BaseAuthParams

  authParams.sign = getSignedData(authParams, secret, encode)
  return authParams
}
